import { Link } from "react-router-dom";
import { useLang } from "@/lib/lang";

export default function NotFound() {
  const { t } = useLang();
  return (
    <div data-testid="not-found-page" className="container-x flex min-h-[80vh] flex-col items-start justify-center pt-32">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-white/40">404</p>
      <h1 className="mt-6 font-display text-6xl font-extrabold tracking-[-0.05em] sm:text-8xl">{t.notFound.title}</h1>
      <Link to="/" data-testid="not-found-home-link" className="btn-primary mt-10">{t.notFound.cta}</Link>
    </div>
  );
}
